import { UnstyledButton } from '@mantine/core';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import 'app/modules/wallforming/custom-styles/customAnnotationStyle.css';

const ROTATION_UNIT = 'deg';

interface TransformationUnitProps {
    isTranslation: boolean;
    isScaling: boolean;
}

export const TransformationUnit = ({ isTranslation, isScaling }: TransformationUnitProps) => {
    const unit = usePlacementStore(useShallow((state) => state.lengthUnit));

    return (
        <UnstyledButton className="unit-selector">
            <span className="unit-selector-text">
                {isTranslation || isScaling ? unit : ROTATION_UNIT}
            </span>
        </UnstyledButton>
    );
};
